import { BatchFileFilterDTO } from '@beable/roster-backend-client-v1';
import { Box, Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { Fragment, useEffect } from 'react';
import batchService from '../../../services/BatchService';
import { getStyles } from './styles'


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

interface ResultsModalProps {
  open: boolean;
  warnings: BatchFileFilterDTO[];
  handleClose: () => void;
  selectedFile?: string | null;
  batchId?: string;
  pages: number;
}
const initialData: BatchFileFilterDTO[] = [];
export default function ResultsModal(props: ResultsModalProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [page, setPage] = React.useState(0);
  const [data, setData] = React.useState(initialData);
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      if (page > 0) {
        const filteredData = await batchService.getBatchFilteredData(props.batchId || "", page, props.selectedFile ? props.selectedFile : "");
        if (filteredData) {
          setData(filteredData.data);
        }
      }
      setIsLoading(false);
    };
    fetchData();
  }, [page, props.batchId, props.selectedFile]);

  const resetState = () => {
    setIsLoading(false);
    setPage(0);
    setData(initialData);
  }
  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={props.open}
      onClose={() => {
        resetState();
        props.handleClose();
      }}
    >
      <Box sx={[modalStyle, styles.paper]}>
        <Typography variant="h4">{props.selectedFile ? `Filtered Records for file ${props.selectedFile}` : "Data Consistency Warnings"}</Typography>
        <TableContainer component={Paper}>
          {props.pages > 1 ? <Box sx={styles.pageControls}>
            <em>Displaying page {page + 1} of {props.pages}</em> &nbsp;&nbsp;&nbsp;&nbsp;
            {page > 0 ? <Button onClick={() => { setPage(page - 1); setIsLoading(true) }}>{"Prev"}</Button> : null}
            <em>{page * 1000 + 1} - {page * 1000 + 1000}</em>
            {page + 1 < props.pages ? <Button onClick={() => { setPage(page + 1); setIsLoading(true) }}>{"Next"}</Button> : null} &nbsp;&nbsp;&nbsp;&nbsp;
            <em>Toolbox: </em>
            {page > 0 ? <Button onClick={() => { setPage(0); setIsLoading(true) }}>{"First page"}</Button> : null}
            {page !== props.pages - 1 ? <Button onClick={() => { setPage(props.pages - 1); setIsLoading(true) }}>{"Last page"}</Button> : null}

          </Box> : <Box sx={styles.pageControls}>
              <em>Displaying page {page + 1} of {props.pages}</em>
          </Box>
          }
          {isLoading ? <CircularProgress color='primary' /> : (
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Legacy Batch ID</TableCell>
                  <TableCell align="left">Reason</TableCell>
                  <TableCell align="left">Explanation</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {page > 0 ? data.map((warning, index) => {
                  if ((props.selectedFile && props.selectedFile === warning.fileName)) {
                    return (
                      <TableRow key={index}>
                        <TableCell align="left">{warning.batchId}</TableCell>
                        <TableCell align="left">{warning.filterReason.replace(/;/g, ' ')}</TableCell>
                        <TableCell align="left" sx={styles.recordCell}>{warning.recordData}</TableCell>
                      </TableRow>
                    );
                  } else if (!props.selectedFile && !warning.fileName.includes('.csv')) {
                    return (
                      <TableRow key={index}>
                        <TableCell align="left">{warning.batchId}</TableCell>
                        <TableCell align="left">{warning.filterReason.replace(/;/g, ' ')}</TableCell>
                        <TableCell align="left" sx={styles.recordCell}>{warning.recordData}</TableCell>
                      </TableRow>
                    );
                  } else {
                    return (<Fragment key={index}></Fragment>);
                  }
                }) : undefined}
                {page === 0 ? props.warnings.map((warning, index) => {
                  if ((props.selectedFile && props.selectedFile === warning.fileName)) {
                    return (
                      <TableRow key={index}>
                        <TableCell align="left">{warning.batchId}</TableCell>
                        <TableCell align="left">{warning.filterReason.replace(/;/g, ' ')}</TableCell>
                        <TableCell align="left" sx={styles.recordCell}>{warning.recordData}</TableCell>
                      </TableRow>
                    );
                  } else if (!props.selectedFile && !warning.fileName.includes('.csv')) {
                    return (
                      <TableRow key={index}>
                        <TableCell align="left">{warning.batchId}</TableCell>
                        <TableCell align="left">{warning.filterReason.replace(/;/g, ' ')}</TableCell>
                        <TableCell align="left" sx={styles.recordCell}>{warning.recordData}</TableCell>
                      </TableRow>
                    );
                  } else {
                    return (<Fragment key={index}></Fragment>);
                  }
                }) : undefined}
              </TableBody>
            </Table>
          )}

        </TableContainer>
      </Box>
    </Modal>
  );
}
